<template>
  <div>
    <v-container fluid></v-container>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  created() {},
};
</script>
